import React, { Fragment } from "react";
// import Plyr from "react-plyr";
import VideoPlayer from "./VideoPlayer";

interface IProps {
  src: string;
}

export default function Video(props: IProps) {
  const { src } = props;
  return (
    <Fragment>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <VideoPlayer
          source={src}
          options={{
            controls: ["play", "rewind", "current-time", "volume", "fullscreen", "settings"],
          }}
        />
      </div>
    </Fragment>
  );
}
